<template>
<div class="create-goal">
  <modal 
    v-if="state==='NEW_GOAL'" 
    title="Create Goal" 
    btn="Next" 
    @close="$emit('close')"
    @submit="state = 'MILESTONES'">
    <div class="input">
      <label>What is your goal?</label>
      <input type="text" v-model="goal.goal" required />
    </div>

    <div class="input">
      <label>Why is this important to you?</label>
      <input type="text" v-model="goal.sacrifice" required />
    </div>

  </modal>
  <modal v-else-if="state==='MILESTONES'"
    title="Milestones"
    btn="Next"
    :displayBack='true'
    @back="state='NEW_GOAL'"
    @close="$emit('close')"
    @submit="goToColor">
    <div>Take a moment and think about milestones along the way of achieving 
      <b>"{{goal.goal}}"</b>
    </div>
    <div class="small-top">
      By breaking up larger goals into smaller easier to achieve milestones you can keep up momentum, and celebrate
      your achievements along the way. 
    </div>
    <!-- <a>You can learn more about why milestones are important, and how to make good ones here.</a> -->

    <div class="small-top">
      <label >Milestones</label>
      <div class="input" v-for="(m, i) in milestones" :key="i" wrap="hard" style="height: 100%">
        <div class="row align-center">
          <span class="col" style="margin-top: 10px" v-if="!savingMilestones">
            <span @click.stop="moveMilestone(m, -1)">
              <h-icon style="color:'green'">keyboard_arrow_up</h-icon>
            </span>
            <span @click.stop="moveMilestone(m, 1)">
              <h-icon>keyboard_arrow_down</h-icon>
            </span>
          </span>
          <v-progress-circular
          color="orange"
          height="10"
          :value='10'
          indeterminate
          v-else
          ></v-progress-circular>
          <textarea class="full-width" v-model="m.text"  rows="2"></textarea>
          <i class="material-icons clickable" @click="removeMilestone(m)">delete</i>
        </div>
      </div>
    </div>
    <div class="input">
      <textarea v-model="milestone" rows="2" wrap="hard"></textarea>
      <button type="button" class="flex-end" @click="addMilestone">
        <i class="material-icons">add</i>
        <span>Add Milestone</span>
      </button>
    </div>
  </modal>

  <modal v-else-if="state==='COLOR'"
    title="Pick a Color"
    btn="Save"
    :displayBack='true'
    :disabled="saving"
    @back="state='MILESTONES'"
    @close="$emit('close')"
    @submit="submit">
    <div class="input">
      <label>Pick a color for this goal</label>
      <swatches :value="goal.color" @input="c => goal.color = c.hex" class="full-width small-top" />
    </div>
    <div class="error-msg small-top" v-if="error">
      {{error}}
    </div>
  </modal>
  </div>
</template>

<script>
// import modal from "@/components/modal";
import modal from "@/components/modal/default";
import { Swatches } from "vue-color";
import store from "@/services/api/store";

export default {
  props: ["goal"],
  components: { modal, Swatches },
  data() {
    return {
      state: 'NEW_GOAL',
      milestone: "",
      error: "",
      saving: false,
      savingMilestones: false,
    };
  },
  computed: {
    milestones() {
      let milestones = [...this.goal.milestones];
      milestones.sort((a, b) => {
        if (a.order > b.order) {
          return 1;
        } else if (b.order === a.order) {
          return 0;
        }
        return -1;
      });
      return milestones;

    }
  },
  methods: {
    goToColor() {
      if (this.milestone) {
        this.addMilestone();
      }
      this.state = "COLOR";
    },
    moveMilestone(milestone, direction) {
      const newOrder = milestone.order + direction;
      if (newOrder < 0 || newOrder >= this.milestones.length) {
        return;
      }
      const switchWith = this.milestones.find(m => m.order === newOrder);
      switchWith.order = milestone.order;
      milestone.order = newOrder;
      if (!this.goal.id) {
        return
      }

      this.savingMilestones = true;
      Promise
        .all([store.cSave("ClientMilestones", milestone), store.cSave("ClientMilestones", switchWith)])
        .finally(() => {
          this.savingMilestones = false;
        })
    },
    removeMilestone(m) {
      if (m.id) {
        store.destroy("ClientMilestones", m.id);
      }
      this.goal.milestones = this.goal.milestones.filter(s => s !== m);
      this.goal.milestones.map((s, i) => {
        s.order = i;
        store.cSave("ClientMilestones", s);
      });
    },
    addMilestone() {
      if (!this.milestone) {
        return;
      }
      this.goal.milestones = [...this.goal.milestones, {text: this.milestone, goal: this.goal.id, order: this.goal.milestones.length}];
      this.milestone = "";
    },
    submit() {
      this.error = "";
      if (this.goal.color == "") {
        this.error = "Please select a color";
        return;
      }
      this.saving = true;
      let milestones = this.milestones;
      store.cSave("ClientGoals", this.goal)
        .then(goal => {
          this.goal_id = goal.id;
          return Promise.all(milestones.map((milestone) => {
            milestone.goal = goal.id;
            return store.cSave('ClientMilestones', milestone);
          })).then(mils => {
            goal.milestones = mils;
            this.$emit('saved', goal);
          })
        }).finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>

<style lang="less">
.create-goal {
  .vdp-datepicker__calendar {
    color: black !important;
  }

  a {
    color: white;
    display: block;
    line-height: 25px;
    font-weight: 800;
    margin: 10px 0px;
  }
}
</style>
